import { useHeaderConfig } from '@/layouts/public/public-header-footer-layout';
import { LRTLogo } from './LRTLogo';

export default function PublicLogo() {
    const { headerConfig } = useHeaderConfig();

    // Determine logo color based on header configuration
    const getLogoColor = () => {
        if (headerConfig.textColor === 'light') return '#F5F5F5';
        if (headerConfig.textColor === 'dark') return '#000000';
        // Auto: use dark logo on white/blur backgrounds, light logo otherwise
        if (headerConfig.background === 'white' || headerConfig.background === 'blur') {
            return '#000000';
        }
        return '#F5F5F5';
    };

    // compactLogoOnMobile shrinks the wordmark on mobile (h-6) so a tagline badge +
    // divider can sit beside it as one cohesive brand cluster in narrow nav rows.
    // Restored to full size at sm+.
    const sizeCls = headerConfig.compactLogoOnMobile ? 'h-6 w-auto sm:h-8 md:h-10' : 'h-8 w-auto md:h-10';

    return (
        <div className="flex items-center">
            <LRTLogo className={sizeCls} style={{ fill: getLogoColor() }} />
        </div>
    );
}
